/**
 * The default language of expression messages (`@dataroom/expr/locale`): tiny on purpose, so the
 * web app's language switch can set it without loading the language itself.
 */
export type ExprLocale = 'en' | 'de';

let defaultLocale: ExprLocale = 'en';

/** `de`, `de-DE`, `de-AT` → `de`; everything else → `en` (empty → the default). */
export function normalizeLocale(locale: string | null | undefined): ExprLocale {
  if (!locale) return defaultLocale;
  return locale.toLowerCase().startsWith('de') ? 'de' : 'en';
}

/** Language of messages when a call does not pass one (the web app sets the member's language). */
export function setExprLocale(locale: string | null | undefined): void {
  defaultLocale = locale && locale.toLowerCase().startsWith('de') ? 'de' : 'en';
}

export function getExprLocale(): ExprLocale {
  return defaultLocale;
}
